module.exports = __webpack_public_path__ + "img/background-twism-gradient.51ebaa54.svg";